import { SDK } from 'document-analyzer'

import { env } from '@app/env'

export const documentAnalyzerSDK = () => {
  return new SDK(env.REACT_APP_DOCUMENT_ANALYZER_PUBLIC_URL)
}
